import React from "react";
import { cn } from "../utils";
import "./styles.css";

type T_props = {
  loading?: boolean;
};

export const Button = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & T_props
>(({ children, className, loading, disabled, ...props }, ref) => {
  return (
    <button
      ref={ref}
      className={cn("relative", className)}
      {...props}
      aria-label={loading ? "Cargando" : undefined}
      disabled={disabled || loading}
    >
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="animation-dot-flashing"></span>
        </div>
      )}
      <span className={cn("flex gap-2", loading && "invisible")}>
        {children}
      </span>
    </button>
  );
});
